{
  "keyboard": {
    "surgeForward": ["KeyW"],
    "surgeBack": ["KeyS"],
    "swayLeft": ["KeyA"],
    "swayRight": ["KeyD"],
    "heaveUp": ["Space"],
    "heaveDown": ["KeyC"],
    "rollLeft": ["KeyQ"],
    "rollRight": ["KeyE"],
    "boost": ["ShiftLeft", "ShiftRight"],
    "toggleFA": ["KeyZ"],
    "toggleCamera": ["KeyV"],
    "pause": ["Escape", "KeyP"],
    "devPanel": ["F2"],
    "perfOverlay": ["F3"],
    "selectPrimary1": ["Digit1"],
    "selectPrimary2": ["Digit2"],
    "target": ["KeyT"],
    "dashboard": ["Tab"],
    "toolCycle": ["Backquote"],
    "toolMining": ["KeyM"],
    "toolSalvage": ["KeyB"],
    "scan": ["KeyR"],
    "dock": ["KeyF"],
    "wirePanel": ["KeyN"],
    "charterBoard": ["KeyK"],
    "fleetScreen": ["KeyU"],
    "wingMenu": ["KeyY"],
    "fleetAlertJump": ["KeyH"],
    "fleetAlertWing": ["KeyI"],
    "turretHoldFire": ["Digit3"],
    "answerHail": ["KeyO"],
    "logs": ["KeyL"]
  },
  "mouse": {
    "sensitivity": 0.002,
    "invertY": false,
    "deadzone": 0.05,
    "exponent": 1.5,
    "recenterRate": 0,
    "firePrimaryButton": 0,
    "fireSecondaryButton": 2,
    "powerWheel": { "enabled": true, "invert": false, "stepPixels": 100 }
  },
  "gamepad": {
    "deadzone": 0.12,
    "exponent": 1.5,
    "triggerThreshold": 0.3,
    "axes": { "sway": 0, "surge": 1, "yaw": 2, "pitch": 3 },
    "invert": { "sway": false, "surge": true, "yaw": false, "pitch": true },
    "buttons": {
      "heaveUp": 0,
      "heaveDown": 1,
      "rollLeft": 4,
      "rollRight": 5,
      "boost": 10,
      "toggleFA": 12,
      "toggleCamera": 13,
      "pause": 9,
      "firePrimary": 7,
      "fireSecondary": 6,
      "cyclePrimary": 2,
      "target": 3,
      "dashboard": 8,
      "toolCycle": 11,
      "powerDown": 14,
      "powerUp": 15
    },
    "scanButton": 2,
    "dockHoldSeconds": 0.5,
    "viewHoldSeconds": 0.5,
    "toolCycleGuardButton": 10,
    "toolCycleTapSeconds": 0.5,
    "wingMenuHoldSeconds": 0.35
  }
}
